import React from 'react';
import ArticleCategories from '../components/ArticlesCategories/ArticleCategories';

export default function Articles() {
  return (
    <div>
      <ArticleCategories />
    </div>
  );
}
